const TAG_NAME = 'shopify-configurator-helper';

if (!customElements.get(TAG_NAME)) {
  class ShopifyConfiguratorHelper extends HTMLElement {
    constructor() {
      super();
      this._setupListeners();
      this._init();
    }

    _init() {
      const frameUrl = new URL('https://designer.coricraft.co.za/za');
      const params = new URL(location.href).searchParams;

      if (params.get('config')) frameUrl.searchParams.set('config', params.get('config'));
      if (params.get('family')) frameUrl.searchParams.set('family', params.get('family'));
      frameUrl.searchParams.set('iframe', '1');

      this.querySelector('iframe')?.setAttribute('src', frameUrl.toString());
    }

    _setupListeners() {
      window.addEventListener('message', this._onMessageEvent.bind(this));
    }

    _onMessageEvent(event) {
      if (event.origin !== 'https://designer.coricraft.co.za') return;
      if (event.data?.type === 'cart:submit') this._onCartSubmit(event);
    }


// _onMessageEvent(event) {
//   // Log EVERYTHING first
//   console.log("=== IFRAME MESSAGE RECEIVED ===");
//   console.log("Origin:", event.origin);
//   console.log("Full event:", event);
//   console.log("event.data:", event.data);
//   console.log("event.data.detail:", event.data?.detail);
//   console.log("Items:", event.data?.detail?.items);

//   // Optional: log each item clearly
//   if (event.data?.detail?.items) {
//     event.data.detail.items.forEach((item, i) => {
//       console.log(`Item ${i}:`, item);
//     });
//   }

//   // Keep your security check
//   if (event.origin !== 'https://designer.coricraft.co.za') return;

//   if (event.data?.type === 'cart:submit') {
//     console.log("Cart submit triggered ✅");
//     this._onCartSubmit(event);
//   }
// }






    async _onCartSubmit(event) {
      showConfiguratorLoader(); // 🔥 SHOW LOADER

      try {
        const items = event.data.detail.items.map(item =>
          this._toCartItem(item, event.data.detail.configuration)
        );

        // Add items ONE BY ONE (Ella requirement)
        for (const item of items) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(item)
          });
        }

        // Refresh Halo sidebar cart (desktop)
        if (window.Shopify?.getCart && window.halo?.updateSidebarCart) {
          Shopify.getCart(cart => halo.updateSidebarCart(cart));
        }

        // Halo refresh triggers (desktop + mobile)
        $(document.body).trigger('cart:refresh');
        $(document.body).trigger('ajaxCart:refresh');
        $(document.body).trigger('ajaxCart:update');
        $(document.body).trigger('mobileCart:refresh');

        // Reload sidebar cart HTML (mobile fix)
        fetch('/?sections=halo-cart-sidebar')
          .then(r => r.json())
          .then(data => {
            if (data['halo-cart-sidebar']) {
              const sidebar = document.querySelector('.halo-cart-sidebar');
              if (sidebar) sidebar.innerHTML = data['halo-cart-sidebar'];
            }
          });

        // Update cart count everywhere
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            document.querySelectorAll('[data-cart-count], .cart-count-bubble span')
              .forEach(el => el.textContent = cart.item_count);
          });

        // Open Ella cart drawer (native way)
        setTimeout(() => {
          document.querySelector('[data-cart-sidebar], #cart-icon-bubble')?.click();
        }, 400);

      } finally {
        // Hide loader after drawer opens
        setTimeout(hideConfiguratorLoader, 700);
      }
    }

    _toCartItem(item, configuration) {
      if (!item.variant_id) throw new Error('Missing variant_id');
console.log("Modular Builder Config",item)
      return {
        id: item.variant_id,
        quantity: item.quantity || 1,
        properties: {
          _planner_code: configuration.code,
          _isParent: ""
        }
      };
    }
  }

  customElements.define(TAG_NAME, ShopifyConfiguratorHelper);
}
